<ngx-page-container>
  <h1>Business Units</h1>
  <hr>
  <ngx-form-list-business-unit [businessUnits]="data.businessUnits" (onSave)="save($event)">

  </ngx-form-list-business-unit>

</ngx-page-container>
